/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ShowamiRequestId
 */
export interface ShowamiRequestId {
}

/**
 * Check if a given object implements the ShowamiRequestId interface.
 */
export function instanceOfShowamiRequestId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShowamiRequestIdFromJSON(json: any): ShowamiRequestId {
    return ShowamiRequestIdFromJSONTyped(json, false);
}

export function ShowamiRequestIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowamiRequestId {
    return json;
}

export function ShowamiRequestIdToJSON(value?: ShowamiRequestId | null): any {
    return value;
}

